import { render, staticRenderFns } from "./personal-data-consent.page.vue?vue&type=template&id=099ee3ca&"
import script from "./personal-data-consent.page.vue?vue&type=script&lang=js&"
export * from "./personal-data-consent.page.vue?vue&type=script&lang=js&"
import style0 from "./personal-data-consent.page.vue?vue&type=style&index=0&id=099ee3ca&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports